import { components } from 'react-select';
import { Option } from '@trukt/portal-utils/Option';

import { SingleValueProps } from './SingleValue.types';
import { SelectOptionProps } from '../../SelectOption.types';
import { Typography } from '../../../../../Typography';

export const SingleValue = ({ children, ...rest }: SingleValueProps) => {
  const option = rest.getValue()[0] as Option;
  const selectProps = rest.selectProps as unknown as SelectOptionProps;

  const optionIndex = selectProps.options?.findIndex((item) => item.value === option.value);
  return (
    <components.SingleValue {...rest}>
      {selectProps.optionFormatter ? (
        selectProps.optionFormatter(
          {
            option,
            variant: 'value',
          },
          optionIndex,
        )
      ) : (
        <Typography variant="h5" className="capitalize">
          {children}
        </Typography>
      )}
    </components.SingleValue>
  );
};
